var ambu         = ambu || {};
ambu.deferImages = {
    settings: {
        deferClass: 'js-e-content-defer',
        preloadClass: 'e-content-defer-placeholder',
        loadingClass: 'is-deferred',
        loadedClass: 'has-loaded',
        backgroundTags: [
            'div',
            'span'
        ],
        observerOptions: {
            rootMargin: '400px 320px'
        },
        reflowClassName: '.js-deferred-image-reflow'
    },
    _hasDomObserver: false, 
    utils: {
        isBackgroundTag: function ( domElmTag ) {
            return ambu.deferImages.settings.backgroundTags.indexOf( domElmTag ) > -1;
        },
        getClosestSrcSetSize: function ( strDataSrcset ) {
            //polyfill for fallback srcset
            var intMaxWidth         = ( window.innerWidth > 0 ) ? window.innerWidth : screen.width,
                intMaxHeight        = ( window.innerHeight > 0 ) ? window.innerHeight : screen.height,
                intMaxDensity       = window.devicePixelRatio || 1,
                arrSrcsetCandidates = strDataSrcset.split( ',' );
            for ( var i = 0; i < arrSrcsetCandidates.length; i++ ) {
                // The following regular expression was created based on the rules
                // in the srcset W3C specification available at:
                // http://www.w3.org/html/wg/drafts/srcset/w3c-srcset/
                var descriptors = arrSrcsetCandidates[i].match(
                        /^\s*([^\s]+)\s*(\s(\d+)w)?\s*(\s(\d+)h)?\s*(\s(\d+)x)?\s*$/
                    ),
                    strFilename = descriptors[1],
                    intWidth = descriptors[3] || false,
                    intHeight = descriptors[5] || false,
                    intDensity = descriptors[7] || 1;

                if (intWidth && intWidth < intMaxWidth) {
                    continue;
                }

                if (intHeight && intHeight < intMaxHeight) {
                    continue;
                }

                if (intDensity && intDensity > intMaxDensity) {
                    continue;
                }
                return strFilename;
            }
        },
        getElements: function () {
            return jQuery( '.' + ambu.deferImages.settings.deferClass ).toArray();
        }
    },
    init: function () {
        ambu.deferImages.bindIntersectionObserver();
        ambu.deferImages.bindMutationObserver();
    },
    bindIntersectionObserver: function () {
        var arrDomElementsToDefer = ambu.deferImages.utils.getElements();
        if ( arrDomElementsToDefer.length > 0 ) {
            e4.util.observer.bind( arrDomElementsToDefer, ambu.deferImages.onElementIntersection, ambu.deferImages.settings.observerOptions );
        }
    },
    bindMutationObserver: function () {
        var domReflowTargets = document.querySelectorAll( ambu.deferImages.settings.reflowClassName );
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

        jQuery( domReflowTargets ).each( function ( index, domElm ) {
            if ( domElm.nodeType !== 1 ) {
                return;
            }
            if ( MutationObserver ) {
                var mutationObserver = new MutationObserver( ambu.deferImages.bindIntersectionObserver  )
                mutationObserver.observe( domElm, {
                    childList: true,
                    subtree: true
                } )
                return mutationObserver
            }
            else if ( window.addEventListener ) {
                domElm.addEventListener( 'DOMNodeInserted', ambu.deferImages.bindIntersectionObserver , false )
                domElm.addEventListener( 'DOMNodeRemoved', ambu.deferImages.bindIntersectionObserver , false )
            }
        } )
    },
    onElementIntersection: function ( domElm, observer ) {
        if ( domElm.isIntersecting === true ) {
            var domElmTarget  = domElm.target,
                domElmTag     = domElmTarget.tagName.toLowerCase(),
                strDataSrc    = jQuery( domElmTarget ).data( 'src' ),
                strDataSrcset = jQuery( domElmTarget ).data( 'srcset' );
            if ( domElmTag === 'img' ) {
                ambu.deferImages.setImageSrc( domElmTarget, strDataSrc, strDataSrcset );
            }
            else if ( ambu.deferImages.utils.isBackgroundTag( domElmTag ) === true ) {
                ambu.deferImages.setImageBackgroundSrc( domElmTarget, strDataSrc, strDataSrcset );
            }
            else if ( domElmTag === 'video' ) {
                ambu.deferImages.setVideoSrc( domElmTarget );
            }
            else if ( domElmTag === 'iframe' ) {
                ambu.deferImages.setIframeSrc( domElmTarget, strDataSrc );
            }
            else {
                console.warn( 'Not a valid lazyload tag: ' + domElmTag );
            }
            observer.unobserve( domElmTarget );
        }
    },
    setImageSrc: function ( domElmTarget, strDataSrc, strDataSrcset ) {
        ambu.deferImages.loadTarget( domElmTarget, ambu.deferImages.showLoadedTarget );
        if ( strDataSrcset !== undefined ) {
            jQuery( domElmTarget ).attr( 'srcset', strDataSrcset );
        }
        else {
            jQuery( domElmTarget ).attr( 'src', strDataSrc );
        }
    },
    setImageBackgroundSrc: function ( domElmTarget, strDataSrc, strDataSrcset ) {
        if (strDataSrcset !== undefined) {
            var strClosestSrcsetMatch = ambu.deferImages.utils.getClosestSrcSetSize(strDataSrcset);
            if (strClosestSrcsetMatch) {
                jQuery(domElmTarget).css('background-image', 'url(' + strClosestSrcsetMatch + ')');
            } else{
                jQuery(domElmTarget).css('background-image', 'url(' + strDataSrc + ')');
            }
        } else {
            jQuery(domElmTarget).css('background-image', 'url(' + strDataSrc + ')');
        }
        ambu.deferImages.showLoadedTarget( domElmTarget );
    },
    setVideoSrc: function ( domElmTarget ) {
        var videoSrc = "";
        if (window.matchMedia("(max-width: 768px)").matches) {
            videoSrc = domElmTarget.dataset.mobilesrc;
        }
        if (!videoSrc && window.matchMedia("(max-width: 992px)").matches) {
            videoSrc = domElmTarget.dataset.tabletsrc;
        }
        if (!videoSrc) {
            videoSrc = domElmTarget.dataset.desktopsrc;
        }
        if (!videoSrc) {
            videoSrc = domElmTarget.dataset.src;
        }
        domElmTarget.src = videoSrc;
        domElmTarget.load();
        if ( jQuery(domElmTarget).hasClass( 'js-ambu-section-video') ) {
            domElmTarget.play();
        }
        ambu.deferImages.showLoadedTarget( domElmTarget );
    },
    setIframeSrc: function ( domElmTarget, strDataSrc ) {
        ambu.deferImages.loadTarget( domElmTarget, ambu.deferImages.showLoadedTarget );
        jQuery( domElmTarget ).attr( 'src', strDataSrc );
    },
    loadTarget: function ( domElmTarget, fnCallback ) {
        jQuery( domElmTarget ).one( 'load', function () {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( domElmTarget );
            }
        } );
    },
    showLoadedTarget: function ( domElmTarget ) {
        if ( ambu.deferImages.settings.loadedClass !== '' && domElmTarget.classList.contains( ambu.deferImages.settings.loadingClass ) === true ) {
            jQuery( domElmTarget ).addClass( ambu.deferImages.settings.loadedClass );
        }
        jQuery( domElmTarget ).removeClass( [
            ambu.deferImages.settings.preloadClass,
            ambu.deferImages.settings.deferClass
        ].join( ' ' ) );
    }
};